module.exports = __webpack_public_path__ + "img/LV40003551060.1aeeaad2.svg";